// extracted by mini-css-extract-plugin
export var header = "news-and-events-module--header--3xUR1";
export var horizontalLine = "news-and-events-module--horizontal-line--hLJt9";
export var listItems = "news-and-events-module--list-items---cbTQ";
export var rectangleWrapper = "news-and-events-module--rectangle-wrapper--qp-Cg";
export var text = "news-and-events-module--text--S5-jt";
export var title = "news-and-events-module--title--abK86";